module.exports = __webpack_public_path__ + "img/vet_day_in_life_splash.2ce9f898.jpg";